export default "__VITE_ASSET__Dhj2wgom__"